import React from 'react';
import { MapPin } from 'lucide-react';
import { DisplayStand } from '../../types';

interface StandHeaderProps {
  stand: DisplayStand;
}

const StandHeader: React.FC<StandHeaderProps> = ({ stand }) => {
  return (
    <>
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">{stand.name}</h1>
        <div className="flex items-center gap-2">
          <span className={`px-3 py-1 rounded-full text-sm font-medium ${
            stand.isReserved 
              ? 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300' 
              : 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300'
          }`}>
            {stand.isReserved ? 'Réservé' : 'Disponible'}
          </span>
        </div>
      </div>

      <div className="flex items-center text-gray-600 dark:text-gray-300 gap-2">
        <MapPin className="h-5 w-5 text-blue-500 dark:text-blue-400" />
        <span className="text-lg">{stand.location}</span>
      </div>
    </>
  );
};

export default StandHeader;